import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { OrderStatus } from "../enums"; 
import { IAPIRelatedOrdersGridModel } from "../interfaces"; 

export class OrderRelatedGridModel {
    id: string;
    createdDate: Date;
    status: keyof typeof OrderStatus;
    amount: number;
    totalItems: number;
    description: string;
    constructor(data: Partial<OrderRelatedGridModel> = {}) {
        this.id = data.id || '';
        this.createdDate = data.createdDate || new Date();
        this.status = data.status || OrderStatus.Draft;
        this.amount = data.amount || 0;
        this.totalItems = data.totalItems || 0;
        this.description = data.description || '';
    }

    static deserializeAPIModel(data: IAPIRelatedOrdersGridModel): OrderRelatedGridModel {
        const mappedData: Partial<OrderRelatedGridModel> = {
            id: data.id,
            createdDate: UtilityMethods.removeZFromDateString(data.createdDate),
            status: data.status,
            amount: data.amount,
            totalItems: data.totalItems,
            description: data.description,
        };

        return new OrderRelatedGridModel(mappedData);
    }
}
